import { useAuthContext } from './useAuthContext';
import { getManageSubscriptionPath } from '/src/features/_global/constants';

export function useManageSubscriptionPath() {
  const { subscription, currentAccount } = useAuthContext();
  const planType = subscription?.plan?.type;
  const subscriptionState = subscription?.state;
  const isStripeUser = Boolean(currentAccount?.useStripe);
  const isShopifyUser = Boolean(currentAccount?.isShopifyUser);

  return getManageSubscriptionPath({ planType, subscriptionState, isStripeUser, isShopifyUser });
}
